import { Grid, Stack, Typography } from '@mui/material';
import { Icon } from '@/components/shared/icon';

export const EmptyList = () => (
  <Grid container justifyContent={{ md: 'center' }} spacing={1}>
    <Grid textAlign={{ md: 'center' }} size={12}>
      <Icon name="family-thin" size={140} />
    </Grid>
    <Grid size={{ xs: 12, md: 6 }}>
      <Stack spacing={2}>
        <Typography variant="h2" textAlign={{ md: 'center' }}>
          Compartilhe a Galena com seus dependentes.
        </Typography>
        <Typography textAlign={{ md: 'center' }}>
          Dê acesso aos recursos da Galena para cônjuge e filhos. Não há limite
          para filhos e os descontos permanecem mesmo que o acesso a Galena
          termine.
        </Typography>
      </Stack>
    </Grid>
  </Grid>
);
